module.exports = __webpack_public_path__ + "execute-octopus-server.ef2ee1e596133aeab3c28db1773315b8.hashedasset.svg";